export const SOCIAL_MEDIA_PLATFORMS = [
  { key: 'gmail_1', label: 'Gmail 01' },
  { key: 'gmail_2', label: 'Gmail 02' },
  { key: 'microsoft365', label: 'Microsoft 365' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'whatsapp', label: 'WhatsApp' },
  { key: 'facebook', label: 'Facebook' },
  { key: 'telegram', label: 'Telegram' },
];
